// extracted by mini-css-extract-plugin
export default {"p_tye":"_6bba5c4b04","slcted":"ed0d909ef3","slc_color":"_690b75eb55","item_p":"e7aa15b2c2","r0":"a876faae52"};